import React from "react";
import { Card, CardContent } from "@/components/ui/card";
const rights = ["Aceder e consultar integralmente os seus dados clínicos e informações de saúde registadas na plataforma.", "Solicitar a retificação imediata de dados incorretos ou a portabilidade da sua informação digital.", "Revogar consentimentos previamente fornecidos e solicitar a eliminação definitiva dos seus dados pessoais.", "Obter esclarecimentos transparentes sobre a finalidade e o período de conservação dos dados tratados."];
const obligations = ["Garantir a exatidão e veracidade das informações clínicas facultadas para segurança do seu diagnóstico.", "Proteger a confidencialidade das credenciais de acesso, evitando a partilha da conta com terceiros.", "Utilizar as funcionalidades da plataforma de forma ética, respeitando as normas de segurança vigentes.", "Notificar a instituição sobre qualquer irregularidade detetada ou suspeita de uso indevido da conta."];
export default function UserRightsAndObligations() {
  return <section data-section-id="185946" id="direitos-dos-utilizadores" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-[1280px]">
        <Card className="rounded-[12px] shadow-[0_8px_30px_rgb(0,0,0,0.04)] border-none bg-card overflow-hidden">
          <CardContent className="p-8 md:p-12 lg:p-16">
            <h2 className="text-[40px] font-default font-bold text-foreground mb-12 text-center tracking-tight">
              Direitos e Deveres do Utente
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
              {}
              <div>
                <h3 className="text-2xl font-default font-semibold text-primary mb-8 border-b border-border pb-4">
                  Direitos de Privacidade
                </h3>
                <ul className="space-y-8">
                  {rights.map((right, index) => <li key={index} data-index={index} className="flex gap-5 items-start">
                      <span className="text-secondary font-semibold font-default text-xl leading-none mt-1 shrink-0">
                        {(index + 1).toString().padStart(2, '0')}.
                      </span>
                      <p className="text-muted-foreground leading-[1.6] text-base md:text-lg font-default">
                        {right}
                      </p>
                    </li>)}
                </ul>
              </div>

              {}
              <div>
                <h3 className="text-2xl font-default font-semibold text-primary mb-8 border-b border-border pb-4">
                  Deveres e Responsabilidades
                </h3>
                <ul className="space-y-8">
                  {obligations.map((obligation, index) => <li key={index} data-index={index} className="flex gap-5 items-start">
                      <span className="text-secondary font-semibold font-default text-xl leading-none mt-1 shrink-0">
                        {(index + 1).toString().padStart(2, '0')}.
                      </span>
                      <p className="text-muted-foreground leading-[1.6] text-base md:text-lg font-default">
                        {obligation}
                      </p>
                    </li>)}
                </ul>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}